module.exports = __webpack_public_path__ + "static/media/no-product-image.6b01e4a9.png";